jQuery(document).ready(function ($) {
  // show mobile menu on click
  $('.show-mobile-menu').on('click', function(e){
      $(".mobile-menu, .body_overlay").toggleClass("hidden");
      $("body").toggleClass("body_transform body_fixed");
      e.stopPropagation();
  });

  // close mobile menu on click
  $('#close_icon').on('click', function(e){
      $(".mobile-menu, .body_overlay").toggleClass("hidden");
      $("body").toggleClass("body_transform body_fixed");
      e.stopPropagation();
  });
  
  //show search field on click
  $(".search-btn").on('click', function(e){
      $(".search-box-desktop").show(200);
      e.stopPropagation();
  });

  //close side menu when click anywhere on screen
  $(document).on('click touchstart', function(event) {
      if (!$(event.target).closest(".mobile-menu, .search-box-desktop").length)  {
          $(".mobile-menu, .body_overlay").addClass("hidden");
          //$(".search-box-desktop").hide(200);
          $("body").removeClass("body_transform body_fixed");
      }
  });
  
  //show mobile sub menu on click
  $(".m_ul-menu .sub-menu").hide();
  $('.m_ul-menu li:has(ul)').click(function(e) {
      // $(this).next('ul').slideToggle();
      $(this).siblings().children("ul").hide();
      if ($(this).children("ul").is(':visible') != true) {
          $(this).children("ul").slideToggle();
          e.preventDefault();
          return false;
      }
  });

  //latest products slider
  jQuery(".latest-prod").owlCarousel({
      dots: false,
      loop: true,
      autoplay: true,
      slideSpeed: 2000,
      margin: 25,
      responsiveClass: true,
      nav: false,
      autoplayHoverPause: true,
      navText: ["<i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i>", "<i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i>"],
      responsive: {
          0: {
              items: 1,
          },
          400: {
              items: 1,
          },
          600: {
              items: 2,
          },

          900: {
              items: 3,
          },

          1000: {
              items: 4,
          },

          1200: {
              items: 4,
          }
      }

  });

  //Testimonial slider
  $('.testimonial-slider').owlCarousel({
      dots: false,
      loop:true,
      margin:30,
      responsiveClass:true,
      autoplay:true,
      nav: false,
      navText: ["<i class=\"fa-solid fa-angle-left\"></i>", "<i class=\"fa-solid fa-angle-right\"></i>"],
      responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:2
          },
          1200:{
              items:3
          },
          1400:{
              items:3
          }
      }
  });

  //Top welcome slider
  $('.welcome-slider').owlCarousel({
    dots: false,
    loop: true,
    autoplay: true,
    /*slideSpeed: 2000,
    scrollbarType: "scroll",
    singleItem: true,*/
    margin: 50,
    responsiveClass: true,
    nav: false,
    autoHeight: true,
    slideTransition: 'linear',
    autoplayTimeout: 5000,
    smartSpeed: 5000,
    autoplaySpeed: 5000,
    autoplayHoverPause: true,
    center: false,
    autoWidth: true,
    navText: ["<i class=\"fa-solid fa-angle-left\"></i>", "<i class=\"fa-solid fa-angle-right\"></i>"],
    responsive: {
      0: {
        items: 1,
      },
        575.98: {
            items: 1,
        },

        767.98: {
            items: 1,
        },

        991.98: {
            items: 1,
        },

        1199.98: {
            items: 1,
        },

        1399.98: {
            items: 1,
        }
    }
    });

  //main menu bar sticky on scroll
  jQuery(document).on('scroll', function() {
      if ($(this).scrollTop() > 220) {
          $('.bottom-bar').addClass('sticky');
      } else {
          $('.bottom-bar').removeClass('sticky');
      }
  });

  //add caret icon to those who have sub menu
  $('.main-nav li:has(ul):has(li), .m_ul-menu li:has(ul)').addClass('drop-caret');

  //scroll to top button show on scroll
  $(document).scroll(function() {
      var y = $(this).scrollTop();
      if (y > 800) {
          $('.scroll_top').fadeIn();
      } else {
          $('.scroll_top').fadeOut();
      }
  });

  //click button to scroll to top
  $("#scroll_top").on("click", function() {
      $("html").scrollTop(0);
  });

  //side bar heading toogle view
  jQuery(".widget.woocommerce ul, .widget.woocommerce form").hide();
  jQuery('.widget.woocommerce .widget-title').on('click',function(){
      jQuery(this).next("ul, form").slideToggle();
      jQuery(this).toggleClass('opened');
  });

  //mobile filter button toggle
  jQuery('.widget-pos-sticky .filter-mobile-btn').on('click',function(){
      jQuery(".filter-btn-hide-div").slideToggle();
  });

  //footer heading toggle
  var alterClass = function() {
      var ww = document.body.clientWidth;
      if (ww <= 768) {
          $('.top-footer .widget-title').addClass('mobile-toggle-title');
          jQuery(".top-footer .mobile-toggle-title").next("div").hide();
      } else if (ww >= 769) {
          $('.top-footer .widget-title').removeClass('mobile-toggle-title');
          jQuery(".top-footer .widget-title").next("div").show();
      };
  };
  $(window).resize(function(){
      alterClass();
  });
  //Fire it when the page first loads:
  alterClass();
  jQuery('.top-footer .mobile-toggle-title').on('click',function(){
      jQuery(this).next("div").slideToggle();
      jQuery(this).toggleClass('opened');
  });


});